export default __webpack_public_path__ + "static/Rousselot-96ad2e2618c98b71bf00834a0c7d6504.png";